import { Component, Input } from '@angular/core';
import { CommonModule, NgStyle } from '@angular/common';

@Component({
  selector: 'bo-summary-card',
  standalone: true,
  imports: [CommonModule, NgStyle],
  templateUrl: './summary-card.component.html'
})
export class SummaryCardComponent {
  @Input({ required: true }) title!: string;
  @Input() iconBackground = '#1C82FF';
  @Input() iconSize = '2.75rem';
  @Input() iconBorderRadius = '0.75rem';
  @Input() iconPadding = '0';
  @Input() titleClass = 'text-[14px] font-semibold text-[color:var(--text-color)] tracking-normal';
  @Input() valueClass = 'text-[28px] font-bold text-[color:var(--text-color)] leading-none';
  @Input() descriptionClass = 'text-[12px] font-normal text-[color:var(--text-color-secondary)]';
}
